// extracted by mini-css-extract-plugin
module.exports = {"pickupAddressPage":"PickupAddress_pickupAddressPage__2frr2","title":"PickupAddress_title__3OK73","pickupAddressesList":"PickupAddress_pickupAddressesList__3ZtSi"};